import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchCompetitionById, fetchTeamById } from '../../../../api/index.js';
import { CircularProgress, Typography } from '@mui/material';
import useFetch from '../../../../v2/hooks/useFetch.js';
import FormCompetition from '../create/FormCompetition.js';

const EditCompetition = () => {

    const { id } = useParams()

    const { data, isLoading, error, fetchData } = useFetch(fetchCompetitionById, [id]);

    useEffect(() => {
        if(!id)
            return

        fetchData()

    }, [id])

    useEffect(() => {

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])


    if(isLoading)
        return <CircularProgress/>
    
    if(!data)
        return <Typography sx={{m : 3}}>Aucune compétition trouvée</Typography>

    return <FormCompetition competition={data} />

}

export default EditCompetition